import { useMemo } from 'react';

const TRANSLATIONS = {
  presence_of_trash: 'Наличие мусора',
  surface_cleanliness: 'Чистота поверхности',
  cleaning_request: 'Запрос на уборку',
  presence_of_truck: 'Наличие грузовиков на фото',
  snow_fullness: 'Заполнение снегом',
  brandbook_compliance: 'Соответствие брендбуку',
  signage_compliance: 'Состояние вывески',
  clutter_level: 'Уровень захламленности',
};

function useFormattedResponse(rawResponse) {
  return useMemo(() => {
    if (!rawResponse) return null;

    const { objects = [], recommendations = {}, ...rest } = rawResponse;

    const objectsList = Array.isArray(objects) && objects.length
      ? objects.join(', ')
      : 'Не определено';

    const qualityParameters = Object.entries(rest).reduce((acc, [key, value]) => {
      if (key === 'recommendations' || key === 'objects') return acc;

      const label = TRANSLATIONS[key] || key;

      if (typeof value === 'string' && value.includes('из')) {
        acc[label] = value;
      } else if (typeof value === 'string' || typeof value === 'number') {
        acc[label] = `${value} из 10`;
      } else if (Array.isArray(value)) {
        acc[label] = value.length ? value.join(', ') : 'Не определено';
      }

      return acc;
    }, {});

    const formattedRecommendations = Object.entries(recommendations).reduce((acc, [key, value]) => {
      const label = TRANSLATIONS[key] || key;
      acc[label] = value;
      return acc;
    }, {});

    return {
      objectsList,
      qualityParameters,
      recommendations: formattedRecommendations,
    };
  }, [rawResponse]);
}

export default useFormattedResponse;

/* {
  "objects": ["список объектов на фотографии"],
  "presence_of_trash": 0-10,        // Обязательное, строка
  "surface_cleanliness": 0-10,      // Обязательное, строка
  "recommendations": {
      "presence_of_trash": "текст",
      "surface_cleanliness": "текст",
      "cleaning_request": "текст"
  }
}

{
  "objects": ["список объектов на фотографии"],
  "presence_of_truck": ["список наличия грузовиков на фото"],
  "snow_fullness": 0-10,      // Обязательное, строка
  "recommendations": {
     "cleaning_request": "текст"
  }
} 
  
{
  "objects": ["..."],
  "brandbook_compliance": "X из 10",
  "signage_compliance": "X из 10",
  "clutter_level": "X из 10",
  "recommendations": {
    "brandbook_compliance": "...",
    "signage_compliance": "...",
    "clutter_level": "..."
  }
}
  */
